import React from "react";
import MUIDataTable from "mui-datatables";
import DoughNut from "../Doughnut";

import {
  createMuiTheme,
  MuiThemeProvider,
  useTheme,
} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Datatable = ({ store, handleClick, toggleDrawer }) => {
  const [data, setData] = React.useState([]);
  const [filter, setFilter] = React.useState([]);
  const tableRef = React.useRef(null);
  const [searchText, setSearchText] = React.useState("");

  const handleRowClick = (index, i) => {
    handleClick(index[3].properties);
    toggleDrawer("left", false);
  };

  const getMuiTheme = (isMobile) =>
    createMuiTheme({
      overrides: {
        MuiPaper: {
          root: {
            backgroundColor: "#22252C",
            color: "white",
          },
        },
        MuiTable: {
          root: {
            width: "100%",
            minWidth: "100%",
            maxWidth: "100%",
            bottom: "0",
          },
        },
        MUIDataTableBodyRow: {
          root: {
            width: "100%",
            "&:nth-child(odd)": {
              backgroundColor: "#2C2F36",
            },
            "&:nth-child(even)": {
              backgroundColor: "#31353D",
            },
          },
        },

        MUIDataTableToolbar: {
          icon: {
            color: "white",
          },
          iconActive: {
            color: "white",
          },
        },

        MUIDataTableHeadCell: {
          root: { color: "white" },
          sortActive: { color: "white" },
          sortAction: { color: "white" },
        },
        MuiTableCell: {
          head: {
            backgroundColor: "#2C2F36 !important",
            color: "white",
          },

          root: {
            borderBottom: "0",
          },
        },

        MUIDataTableBodyCell: {
          root: {
            width: "30%",
            padding: "3px",
            paddingLeft: "20px",
            color: "white !important",
          },
        },
        MuiTableFooter: {
          root: {
            width: "100%",
          },
        },
        MUIDataTablePagination: {
          root: {
            padding: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
          },
        },

        MUIDataTable: {
          paper: {
            height: "100vh",
          },
          responsiveScroll: {
            maxHeight: "85vh !important",
          },
        },
        MuiInput: {
          formControl: {
            color: "white",
          },
        },
        MUIDataTableViewCol: {
          title: {
            color: "white",
          },
          label: {
            color: "white",
          },
        },
        MUIDataTableSearch: {
          searchIcon: { color: "white" },
          clearIcon: { color: "white" },
        },
        MuiTableSortLabel: {
          icon: { color: "white !important" },
          active: { color: "white !important" },
          iconDirectionDesc: { color: "white !important" },
          iconDirectionAsc: { color: "white !important" },
        },
      },
    });

  React.useEffect(() => {
    const row = [];

    if (Object.keys(store.features).length > 0) {
      store.features.forEach((index, i) => {
        const doughnut = index.properties.score;
        const address = index.properties.address;
        const country = index.properties.country;
        const data = index;

        row.push([doughnut, address, country, data]);
      });

      setData(row);
    }
  }, [store.features]);

  const columns = [
    {
      name: "Score",
      options: {
        sortDirection: "desc",
        filter: false,
        sort: true,
        customBodyRender: (value, x) => {
          return (
            <div>
              <DoughNut
                DoughNutData={x.tableData[value]}
                width={"120px"}
                score={x.rowData[0]}
                id={x}
              />
            </div>
          );
        },
      },
    },
    {
      name: "City",
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "Country",
      options: {
        filterList: filter,
        filter: true,
        sort: true,
        display: true,
      },
    },

    {
      name: "Data",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
  ];
  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "scroll",
    print: false,
    download: false,
    selectableRowsHeader: false,
    selectableRows: "none",
    viewColumns: true,
    sort: true,
    page: 0,
    rowsPerPageOptions: data.length > 100 ? [50, 100, data.length] : [50, 100],
    rowsPerPage: 50,
    pagination: true,
    searchText,
    onRowClick: (index, i) => handleRowClick(index, i),
    onColumnSortChange: () => {
      tableRef.current.changePage(0);
    },
    onFilterChange: (columnChanged, filterList) => {
      setFilter(filterList[4]);
    },
    onSearchChange: (searchText) => setSearchText(searchText),
    onChangePage: () => {
      const table = document.querySelector("table");
      table.scrollIntoView(true);
    },
  };
  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up("md"));
  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      <MuiThemeProvider theme={getMuiTheme(isMobile)}>
        <MUIDataTable
          innerRef={tableRef}
          title={"City Index"}
          data={data}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    </div>
  );
};

export default Datatable;
